import { isBrandAccentId, type BrandAccentId } from './brandAccentConstants';
import { isThemeMode, type ThemeModeId } from './themeConstants';

/** Persisted light/dark preference (mirrored in `index.html` inline script for first paint). */
export const THEME_STORAGE_KEY = 'selected-theme';

/**
 * Brand accent — `html[data-brand]`.
 * Shared name across host and form apps; avoid product-specific key strings.
 */
export const BRAND_ACCENT_STORAGE_KEY = 'portal-brand-accent';

/** Secure storage key for persisted portal user profile (AuthContext). */
export const AUTH_USER_KEY = 'auth_user';

/** Secure storage key for persisted user profile payload (AuthContext). */
export const AUTH_USER_PROFILE_KEY = 'auth_user_profile';

/**
 * Reads persisted theme from `THEME_STORAGE_KEY`.
 */
export function readThemeFromStorage(): ThemeModeId | null {
  try {
    const cur = localStorage.getItem(THEME_STORAGE_KEY);
    if (isThemeMode(cur)) return cur;
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Reads persisted brand accent from `BRAND_ACCENT_STORAGE_KEY`.
 */
export function readBrandAccentFromStorage(): BrandAccentId | null {
  try {
    const cur = localStorage.getItem(BRAND_ACCENT_STORAGE_KEY);
    if (isBrandAccentId(cur)) return cur;
  } catch {
    /* ignore */
  }
  return null;
}
